module.exports = __webpack_public_path__ + "4e3940b96655241c04abe3e62ad9d121.pdf";